// eslint-disable-next-line import/prefer-default-export, no-shadow
  export enum DriversActionTypes {
    GET_DRIVER = 'GET_DRIVER',
    POST_DRIVER = 'POST_DRIVER',
  }
  